import { ICursorOption } from '../../interface/Cursor'

export const defaultCursorOption: Readonly<Required<ICursorOption>> = {
  width: 1,
  color: '#000',
  dragWidth: 3,
  dragColor: '#007fff'
}
